const normalizeApiBaseUrl = (value: string): string => {
  const trimmed = value.trim().replace(/\/+$/, '');

  if (!trimmed) {
    return 'http://localhost:3000/api';
  }

  try {
    const url = new URL(trimmed);
    const path = url.pathname.replace(/\/+$/, '');

    if (!path || path === '/') {
      url.pathname = '/api';
    } else if (!path.toLowerCase().endsWith('/api')) {
      url.pathname = `${path}/api`;
    }

    return url.toString().replace(/\/+$/, '');
  } catch {
    if (trimmed.toLowerCase().endsWith('/api')) {
      return trimmed;
    }

    return `${trimmed}/api`;
  }
};

const config = {
  API_BASE_URL: normalizeApiBaseUrl(
    import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api',
  ),
  STAGE: import.meta.env.VITE_APP_STAGE || 'dev',
  STRIPE_KEY: import.meta.env.VITE_STRIPE_KEY || '',
  PAYMENT_PROCESSOR: import.meta.env.VITE_PAYMENT_PROCESSOR || 'stripe',
  logrocket: import.meta.env.VITE_LOGROCKET_ENABLED === 'true',
  CDN_URL: import.meta.env.VITE_CDN_URL || 'https://cdn.westprop.com',
  whiteLogo: import.meta.env.VITE_WHITE_LOGO || 'https://cdn.westprop.com/logos/westprop-white.png',
  blueLogo: import.meta.env.VITE_BLUE_LOGO || 'https://cdn.westprop.com/logos/westprop-blue.png',
}

export default config;
